import { render, staticRenderFns } from "./ForestParEn.vue?vue&type=template&id=24a64ff5&scoped=true"
import script from "./ForestParEn.vue?vue&type=script&lang=js"
export * from "./ForestParEn.vue?vue&type=script&lang=js"
import style0 from "./ForestParEn.vue?vue&type=style&index=0&id=24a64ff5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a64ff5",
  null
  
)

export default component.exports